/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PersonalizationRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#search
 */
export const SEARCH_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_search';
export const SEARCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_QUERY_FIELD_NAME,
  args: ['queryType', 'search', 'language', 'collectionId', 'filter', 'sorts', 'offset', 'length', 'suggestionSectionFilter'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.searchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSearchFilterDefinitions
 */
export const GET_SEARCH_FILTER_DEFINITIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSearchFilterDefinitions';
export const GET_SEARCH_FILTER_DEFINITIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEARCH_FILTER_DEFINITIONS_QUERY_FIELD_NAME,
  args: ['language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSearchFilterDefinitionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSections
 */
export const GET_SUGGESTION_SECTIONS_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSections';
export const GET_SUGGESTION_SECTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUGGESTION_SECTIONS_QUERY_FIELD_NAME,
  args: ['maximumSections', 'language', 'minimumSectionCardCount', 'maximumSectionCardCount', 'contexts', 'productTypes'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSuggestionSectionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#getSuggestionSectionsByType
 */
export const GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_getSuggestionSectionsByType';
export const GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUGGESTION_SECTIONS_BY_TYPE_QUERY_FIELD_NAME,
  args: ['sectionTypes', 'language', 'minimumSectionCardCount', 'maximumSectionCardCount', 'contexts', 'productTypes'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSuggestionSectionsByTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.personalization.rpc.PersonalizationRpc#callbackAiResponse
 */
export const CALLBACK_AI_RESPONSE_QUERY_FIELD_NAME = 'com_hubspot_marketplace_personalization_rpc_PersonalizationRpc_callbackAiResponse';
export const CALLBACK_AI_RESPONSE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: CALLBACK_AI_RESPONSE_QUERY_FIELD_NAME,
  args: ['requestId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.callbackAiResponseRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});